import Color from '@/Enums/Color.enum';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

const ClearButton = styled(Button)({
  fontSize: '0.75rem',
  textDecoration: 'underline',
  color: Color.Primary,
  padding: 0,
  minWidth: 'auto',
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: 'transparent',
  },
});

export default ClearButton;
